import { render, staticRenderFns } from "./SafetyEquipmentList.vue?vue&type=template&id=886959f8&scoped=true&"
import script from "./SafetyEquipmentList.vue?vue&type=script&lang=js&"
export * from "./SafetyEquipmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886959f8",
  null
  
)

export default component.exports